import { AreaOfChallengeWithQuestions } from "@appally/collections/AreaOfChallenge";
import { collections } from "@appally/lib/data/firebase";
import { getDocs, orderBy, query } from "firebase/firestore";
import _ from "lodash";

export const getAboutYouQuestions = async () => {
  const docSnap = await getDocs(
    query(collections.about_you_questions, orderBy("question_order", "asc"))
  );
  return docSnap.docs.map((d) => d.data());
};

export const getAboutYourWorkQuestions = async () => {
  const docSnap = await getDocs(
    query(
      collections.about_your_work_questions,
      orderBy("question_order", "asc")
    )
  );
  return docSnap.docs.map((d) => d.data());
};

export const getWorkplaceChallengesQuestions = async (
  questionIds?: string[]
) => {
  if (questionIds?.length) {
    const snap = await getDocs(
      query(
        collections.workplace_challenge_questions,
        orderBy("question_order", "asc")
      )
    );
    return snap.docs
      .filter((d) => questionIds.includes(d.id))
      .map((d) => d.data());
  } else {
    const snap = await getDocs(
      query(
        collections.workplace_challenge_questions,
        orderBy("question_order", "asc")
      )
    );
    return snap.docs.map((d) => d.data());
  }
};

export const getAreasOfChallengeWithQuestions = async () => {
  const data: AreaOfChallengeWithQuestions[] = [];

  const docSnap = await getDocs(
    query(collections.area_of_challenges, orderBy("page_number", "asc"))
  );

  for await (let doc of docSnap.docs) {
    const area = doc.data();
    const questionIds = Object.values(area.question_array ?? {});
    if (!questionIds.length) continue;
    const assessment_questions = await getWorkplaceChallengesQuestions(
      questionIds
    );
    data.push({
      ...area,
      questions: assessment_questions,
    });
  }

  return data;
};

export const getTasks = async () => {
  const docSnap = await getDocs(query(collections.tasks));
  return _.orderBy(
    docSnap.docs.map((d) => d.data()),
    ["type", "priority", "stage"],
    ["asc", "asc", "asc"]
  );
};
